import { render, staticRenderFns } from "./GTrendAnalysisHumanitiesOrSciencesChart.vue?vue&type=template&id=56305ed5&scoped=true&"
import script from "./GTrendAnalysisHumanitiesOrSciencesChart.vue?vue&type=script&lang=ts&"
export * from "./GTrendAnalysisHumanitiesOrSciencesChart.vue?vue&type=script&lang=ts&"
import style0 from "./GTrendAnalysisHumanitiesOrSciencesChart.vue?vue&type=style&index=0&id=56305ed5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56305ed5",
  null
  
)

export default component.exports